<template>
	<SectionCard>
		<template #title>
			IAB GPP MSPA Settings
		</template>
		<template #subtitle>
			As your selected collection template is configured to create an IAB GPP MSPA signal, you will need to specify what notices (if any) are provided to your website users.
			<br>
			Please refer to IAB provided documentation if you are unsure if these are to be MSPA covered transactions, or the correct mode to use.
		</template>
		<template #body>
			<v-row dense>
				<v-col cols="4">
					Sharing Notice:
				</v-col>
				<v-col cols="4">
					<Dropdown
						:value="cookieBanner.mspaSharingNotice"
						:items="mspaSharingNoticeOptions"
						label="Sharing Notice *"
						rules="required"
						:disabled="!userCanCreateUpdate"
						@input="updateBanner('mspaSharingNotice', $event)"
					/>
				</v-col>
			</v-row>
			<v-row dense>
				<v-col cols="4">
					Sale Opt Out Notice:
				</v-col>
				<v-col cols="4">
					<Dropdown
						:value="cookieBanner.mspaSaleOptOutNotice"
						:items="mspaSaleOptOutNoticeOptions"
						label="Sale Opt Out Notice *"
						rules="required"
						:disabled="!userCanCreateUpdate"
						@input="updateBanner('mspaSaleOptOutNotice', $event)"
					/>
				</v-col>
			</v-row>
			<v-row dense>
				<v-col cols="4">
					Sharing Opt Out Notice:
				</v-col>
				<v-col cols="4">
					<Dropdown
						:value="cookieBanner.mspaSharingOptOutNotice"
						:items="mspaSharingOptOutNoticeOptions"
						label="Sharing Opt Out Notice *"
						rules="required"
						:disabled="!userCanCreateUpdate"
						@input="updateBanner('mspaSharingOptOutNotice', $event)"
					/>
				</v-col>
			</v-row>
			<v-row dense>
				<v-col cols="4">
					Targeted Advertising Opt Out Notice:
				</v-col>
				<v-col cols="4">
					<Dropdown
						:value="cookieBanner.mspaTargetedAdvertisingOptOutNotice"
						:items="mspaTargetedAdvertisingOptOutNoticeOptions"
						label="Targeted Advertising Opt Out Notice *"
						rules="required"
						:disabled="!userCanCreateUpdate"
						@input="updateBanner('mspaTargetedAdvertisingOptOutNotice', $event)"
					/>
				</v-col>
			</v-row>
			<v-row dense>
				<v-col cols="4">
					MSPA Covered Transaction:
				</v-col>
				<v-col cols="4">
					<Dropdown
						:value="cookieBanner.mspaCoveredTransaction"
						:items="mspaCoveredTransactionOptions"
						label="MSPA Covered Transaction *"
						rules="required"
						:disabled="!userCanCreateUpdate"
						@input="updateBanner('mspaCoveredTransaction', $event)"
					/>
				</v-col>
			</v-row>
			<v-row dense>
				<v-col cols="4">
					MSPA Mode:
				</v-col>
				<v-col cols="4">
					<Dropdown
						:value="cookieBanner.mspaMode"
						:items="mspaModeOptions"
						label="MSPA Mode *"
						rules="required"
						:disabled="!userCanCreateUpdate"
						@input="updateBanner('mspaMode', $event)"
					/>
				</v-col>
			</v-row>
		</template>
	</SectionCard>
</template>

<script>
import SectionCard from '../../../../../../../shared/components/section-card.vue'
import Dropdown from '../../../../../../../shared/components/dropdown.vue'

export default {
	components: {
		SectionCard,
		Dropdown
	},
	props: {
		cookieBanner: Object,
		userCanCreateUpdate: Boolean,
		updateBanner: Function
	},
	data () {
		return {
			mspaSharingNoticeOptions: [
				{ text: 'N/A', value: 0 },
				{ text: 'No', value: 1 },
				{ text: 'Yes', value: 2 }
			],
			mspaSaleOptOutNoticeOptions: [
				{ text: 'N/A', value: 0 },
				{ text: 'No', value: 1 },
				{ text: 'Yes', value: 2 }
			],
			mspaSharingOptOutNoticeOptions: [
				{ text: 'N/A', value: 0 },
				{ text: 'No', value: 1 },
				{ text: 'Yes', value: 2 }
			],
			mspaTargetedAdvertisingOptOutNoticeOptions: [
				{ text: 'N/A', value: 0 },
				{ text: 'No', value: 1 },
				{ text: 'Yes', value: 2 }
			],
			mspaCoveredTransactionOptions: [
				{ text: 'No', value: 0 },
				{ text: 'Yes', value: 1 }
			],
			mspaModeOptions: [
				{ text: 'Opt Out', value: 1 },
				{ text: 'Service Provider', value: 2 }
			]
		}
	}
}

</script>
